module.exports = __webpack_public_path__ + "img/arrow-down-icon.fa72af22.svg";